var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-container-content", attrs: { id: "chargeInfo" } },
    [
      _c(
        "div",
        {
          staticClass: "table-container-new",
          staticStyle: { display: "flex", "flex-wrap": "wrap" },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { border: "", data: _vm.form.webBkChargeDetailComs },
            },
            [
              _c("el-table-column", { attrs: { type: "index", width: "50" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "containerType",
                  label: _vm.$t("containerInfo.containerType"),
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ofAmount", label: "OF" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "allIn", label: "ALL IN" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }